import { render, staticRenderFns } from "./TbFilaAndamento.vue?vue&type=template&id=c24e754c&scoped=true&"
import script from "./TbFilaAndamento.vue?vue&type=script&lang=js&"
export * from "./TbFilaAndamento.vue?vue&type=script&lang=js&"
import style0 from "./TbFilaAndamento.vue?vue&type=style&index=0&id=c24e754c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c24e754c",
  null
  
)

export default component.exports